import { render, staticRenderFns } from "./ProjectViewer.vue?vue&type=template&id=2c3f66ec&"
import script from "./ProjectViewer.vue?vue&type=script&lang=js&"
export * from "./ProjectViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports